/**
 * Local UUID v4 generator, equivalent to `H5P.createUUID` (the walker is pure
 * and must not depend on the H5P runtime).
 */

const UUID_TEMPLATE = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
const HEX_BASE = 16;
const VARIANT_MASK = 0x3;
const VARIANT_BITS = 0x8;

export const createUuidV4 = (): string =>
  UUID_TEMPLATE.replace(/[xy]/g, placeholder => {
    const random = Math.floor(Math.random() * HEX_BASE);
    const value =
      placeholder === 'x' ? random : (random & VARIANT_MASK) | VARIANT_BITS;
    return value.toString(HEX_BASE);
  });
